var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAnaliseFinanceira(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.454,
    height: 17.453,
    viewBox: "0 0 17.454 17.453",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "statistics",
    transform: "translate(0 -0.008)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2489",
    "data-name": "Caminho 2489",
    d: "M16.007,3.855l1.284,1.824h.883V.566a.558.558,0,0,0-.558-.558H14.892a.558.558,0,0,0-.558.558v2.44A2,2,0,0,1,16.007,3.855Z",
    transform: "translate(-13.492)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2490",
    "data-name": "Caminho 2490",
    d: "M16.254,144.415a2,2,0,0,1-1.634-.848l-.286-.406v8.482a.558.558,0,0,0,.558.558h2.723a.558.558,0,0,0,.558-.558v-6.269l-.371-.959Z",
    transform: "translate(-13.492 -134.74)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2491",
    "data-name": "Caminho 2491",
    d: "M113.9,52.6l.25.646.524-.194a2,2,0,0,1,2.162.52V49.059a.558.558,0,0,0-.558-.558h-2.723a.558.558,0,0,0-.558.558v2.51A2,2,0,0,1,113.9,52.6Z",
    transform: "translate(-106.36 -45.643)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2492",
    "data-name": "Caminho 2492",
    d: "M115.622,201.95l-1.166-2.1-.761.281a1.992,1.992,0,0,1-.693.124V205a.558.558,0,0,0,.558.558h2.723a.558.558,0,0,0,.558-.558v-2.089A2,2,0,0,1,115.622,201.95Z",
    transform: "translate(-106.36 -188.094)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2493",
    "data-name": "Caminho 2493",
    d: "M213.668,250.553v2.171a.558.558,0,0,0,.558.558h2.723a.557.557,0,0,0,.178-.03,1.991,1.991,0,0,1-.734-.394Z",
    transform: "translate(-201.111 -235.821)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2494",
    "data-name": "Caminho 2494",
    d: "M215.409,103.675l2.1,1.775V99.059a.558.558,0,0,0-.558-.558h-2.723a.558.558,0,0,0-.558.558v4.193l.066-.013A2,2,0,0,1,215.409,103.675Z",
    transform: "translate(-201.111 -92.705)",
    fill: "#64c2c8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_2495",
    "data-name": "Caminho 2495",
    d: "M17.142,80.748l-3.565-3.017a.882.882,0,0,0-.739-.192l-1.369.268L9.782,74.764a.882.882,0,0,0-1.077-.4L7.15,74.94,6.5,73.267a.882.882,0,0,0-.822-.564H3.22L1.6,70.406A.881.881,0,1,0,.161,71.421l1.881,2.672a.882.882,0,0,0,.721.374H5.077l.742,1.919a.882.882,0,0,0,1.128.509l1.66-.614,1.631,2.943a.881.881,0,0,0,.941.438l1.582-.31L16,82.094a.881.881,0,1,0,1.139-1.346Z",
    transform: "translate(0 -65.909)",
    fill: "#64c2c8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnaliseFinanceira);
export default __webpack_public_path__ + "static/media/analiseFinanceira.0dea271f8a5cb74ad5c48ff4738301e1.svg";
export { ForwardRef as ReactComponent };